import PropTypes from "prop-types";
import React, { useState } from "react";
import ReactGoogleMapLoader from "react-google-maps-loader";
import ReactGooglePlacesSuggest from "react-google-places-suggest";

const API_KEY = "AIzaSyAkcs8Ts4pbqDXqkc8RY4Xgx73gSgHNF5w";
function GoogleSuggest(props) {
  const [search, setSearch] = useState("");

  function handleInputChange(e) {
    setSearch(e.target.value);
    props.setAddress(e.target.value);
  }

  function handleSelectSuggest(suggest) {
    props.setLat(suggest.geometry.location.lat());
    props.setLng(suggest.geometry.location.lng());
    setSearch("");
    props.setAddress(suggest.formatted_address);
  }

  return (
    <ReactGoogleMapLoader
      params={{
        key: API_KEY,
        libraries: "places,geocode",
      }}
      render={(googleMaps) =>
        googleMaps && (
          <div>
            <ReactGooglePlacesSuggest
              autocompletionRequest={{ input: search }}
              googleMaps={googleMaps}
              onSelectSuggest={handleSelectSuggest}
            >
              <input
                type="text"
                value={props.address}
                placeholder="Search a location"
                className="form-control form-control-lg"
                onChange={handleInputChange}
              />
            </ReactGooglePlacesSuggest>
          </div>
        )
      }
    />
  );
}

GoogleSuggest.propTypes = {
  googleMaps: PropTypes.object,
};

export default GoogleSuggest;
